<template :key="$route.path">
  <router-view :key="$route.path"></router-view>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
